// src/pages/About.jsx
import ViewfinderFrame from "../components/ViewfinderFrame";
import ProcessSteps from "../components/ProcessSteps";
import usePageTitle from "../hooks/usePageTitle";
import "./About.css";

const EQUIPMENT = [
  {
    title: "Drone",
    desc: "Tomadas aéreas em 4K da fachada, do entorno e da vista.",
  },
  {
    title: "Câmera e estabilizador",
    desc: "Fotos tratadas e tour em vídeo estabilizado pelos ambientes.",
  },
  {
    title: "Pós-produção própria",
    desc: "Cor, corte, trilha e formatos para cada canal, sem terceirizar.",
  },
];

function About() {
  usePageTitle("Sobre a D-Rec — D-Rec Produções");

  return (
    <>
      <section className="about-hero">
        <div className="section-head">
          <span className="eyebrow">Sobre a D-Rec</span>
          <h1 className="section-title">A gente filma imóvel. Só isso, e bem feito.</h1>
        </div>
      </section>

      <section className="about-story">
        <ViewfinderFrame tag="D•REC · RMR" className="about-frame">
          <p>
            A D-Rec nasceu em Recife com câmera na mão e drone no ar, filmando de eventos a
            vídeos institucionais. Com o tempo, ficou claro onde nosso trabalho fazia mais
            diferença: no anúncio de um imóvel. Uma boa imagem aérea mostra a localização que o
            texto não explica; um tour em vídeo evita visitas que não iam dar em nada.
          </p>
          <p>
            Hoje a D-Rec é uma equipe enxuta com um foco só: entregar ao corretor e à
            imobiliária, em 48h, o material que faz o anúncio se destacar no portal, no
            Instagram e no WhatsApp. Piloto e fotógrafo na mesma visita e pós-produção própria.
          </p>
        </ViewfinderFrame>
      </section>

      <section className="about-process">
        <div className="section-head">
          <span className="eyebrow">Como trabalhamos</span>
          <h2 className="section-title">Do agendamento à entrega em 48h</h2>
        </div>
        <ProcessSteps />
      </section>

      <section className="about-equipment">
        <div className="section-head">
          <span className="eyebrow">Como captamos</span>
          <h2 className="section-title">Equipamento</h2>
        </div>
        <div className="container card-grid">
          {EQUIPMENT.map((item) => (
            <div key={item.title} className="card">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default About;
